import { type Asserts, object } from "yup";
import { IdArray } from "./shared";

export const SelectContactGroupsSchema = object({
  contactGroups: IdArray.optional(),
});
export type SelectContactGroupsPayload = Asserts<typeof SelectContactGroupsSchema>;
